import React from 'react';
import { dtm } from 'utils/analytics';
import { i18n } from 'utils/i18n';
import ANALYTICS from 'constants/analytics';
import Button from 'components/Button';

const LocationMapCTA = ({ showSoldOutAreaBanner, showRecenterButton, hideSoldOutAreaBanner, handleRecenterMap }) => (
  <div className='map-banner-area'>
    {showSoldOutAreaBanner && (
      <div className='move-map-banner'>
        <Button
          plain
          className='modal__close-btn move-map-banner__close-btn'
          aria-label={`${i18n('close')} ${i18n('move_the_map')}`}
          data-dtm-track={dtm(ANALYTICS.LOCATION_PAGE, ANALYTICS.MAP, ANALYTICS.CLOSE)}
          onClick={hideSoldOutAreaBanner}
        />
        {i18n('move_the_map')}
      </div>
    )}
    {showRecenterButton && (
      <Button
        plain
        type='button'
        className='button pill google-map__button-recenter'
        onClick={handleRecenterMap}
        aria-label={i18n('recenter_map')}
      >
        {i18n('recenter_map')}
      </Button>
    )}
  </div>
);

export default LocationMapCTA;
